import apiClient from '../../../common/services/apiClient';

export default {
  topUp: amount => apiClient.post('/test-tools/topup', { amount }, { apiCallId: 'TEST_TOOLS_TOPUP' }),
  listSms: () => apiClient.get('/test-tools/sms', { apiCallId: 'TEST_TOOLS_SMS_LIST' }),
  listAccountTemplates: () => apiClient.get('/test-tools/account-templates', { apiCallId: 'TEST_TOOLS_ACCOUNT_TEMPLATES' }),
  createAccount: body => apiClient.post('/test-tools/accounts', body, { apiCallId: 'TEST_TOOLS_CREATE_ACCOUNT' }),
};



// WEBPACK FOOTER //
// ./src/features/test-tools/api/index.js